import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderContent,
  IconBoxSkeleton,
  Skeleton
} from '@sollapay/ui/components';

export function AssetTrustSummaryCardSkeleton() {
  return (
    <Card>
      <CardHeader className="items-center">
        <CardHeaderContent>
          <IconBoxSkeleton />
          <div className="flex flex-col gap-2.5">
            <Skeleton className="h-4 w-48" />
            <Skeleton className="h-3 w-64" />
          </div>
        </CardHeaderContent>
        <Skeleton className="h-6 w-20 rounded-full" />
      </CardHeader>
      <CardBody>
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between gap-4">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-6 w-28" />
          </div>
          <Skeleton className="h-1.5 w-full rounded-full" />
          <div className="flex items-center justify-between gap-4">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-28" />
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
